import { render, staticRenderFns } from "./MenuVideosPainel.vue?vue&type=template&id=dff3a116&scoped=true&"
import script from "./MenuVideosPainel.vue?vue&type=script&lang=js&"
export * from "./MenuVideosPainel.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=dff3a116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff3a116",
  null
  
)

export default component.exports